"use client";

import { useEffect, useState } from "react";
import { getPassPageData } from "../win-service";

const SaveSection = () => {
  const [milestonesHtml, setMilestonesHtml] = useState("");

  useEffect(() => {
    getPassPageData()
      .then(res => res.json())
      .then((data: { BiggerMilestones?: string }) => {
        setMilestonesHtml(data?.BiggerMilestones || "");
      })
      .catch(err => console.error("Error fetching pass page data:", err));
  }, []);
  return (
    <div className="w-full lg:px-4">
      <div className="relative mx-auto w-full max-w-[1320px] rounded-t-[32px] bg-[#efefef] shadow-[0px_-15px_100px_0px_rgba(0,0,0,0.04)] lg:rounded-[40px] lg:bg-[#f5f5f5]">
        {/* Money coin decoration */}
        <div className="max-lg:overflow-hidden pointer-events-none absolute right-0 top-[-34px] h-[129px] w-[124px] lg:top-[-75px] lg:h-[187px] lg:w-[180px] min-[1400px]:right-[-33px]">
          <img
            src="/assets/images/win/money-coin.webp"
            alt=""
            className="h-full w-full object-contain max-lg:absolute max-lg:-right-[68px]"
          />
        </div>

        <div className="flex flex-col items-center gap-8 px-5 pb-8 pt-8 lg:gap-[35px] lg:px-8 lg:pb-[58px] lg:pt-14">
          {/* ─── Main content: promo text + winner block ─────── */}
          <div className="flex w-full flex-col items-center gap-8 lg:gap-14">
            {/* Promo text */}
            <div className="flex w-full max-w-[320px] flex-col gap-3 lg:max-w-[715px] lg:gap-4">
              <div className="text-left font-jost text-[24px] font-bold leading-[30px] text-[#28282b] lg:text-center lg:text-[40px] lg:leading-[48px]">
                Save up
                <span className="text-primary"> to 75%</span>
                <span className="font-medium text-[#ff9b33]">*</span>
              </div>
              <div className="flex flex-col gap-2 lg:gap-3 lg:text-center">
                <div className="font-jost text-[13px] font-normal leading-[18px] text-[#6a7282] lg:text-[18px] lg:leading-6">
                  Most of our regular players use BOTB Pass — and for good reason. One monthly subscription enters you
                  into every competition, every month.
                </div>
                <div className="font-jost text-[13px] font-normal leading-[18px] text-[#6a7282] lg:text-[18px] lg:leading-6">
                  You get more entries, better value, and you never miss a draw.
                </div>
              </div>
            </div>

            {/* Winner block: title + photo collage */}
            <div className="flex w-full max-w-[320px] flex-col items-start gap-4 lg:max-w-[715px] lg:items-center">
              {/* Mobile title (inline) */}
              <div className="font-jost text-[20px] font-bold leading-[26px] text-[#28282b] lg:hidden">
                BOTB Pass won James a{" "}
                <span className="text-[24px] leading-[30px] text-primary">£900,000 Essex house</span>
              </div>

              {/* Desktop title (two lines, centered) */}
              <div className="hidden lg:flex lg:flex-col lg:items-center">
                <div className="text-center font-jost text-[32px] font-bold leading-[40px] text-[#28282b]">
                  BOTB Pass won James a
                </div>
                <div className="text-center font-jost text-[40px] font-bold leading-[48px] text-primary">
                  £900,000 Essex house
                </div>
              </div>

              {/* ── Mobile collage ─────────────────────────────── */}
              <div className="relative left-1/2 w-screen -translate-x-1/2 lg:hidden">
                <img
                  src="/assets/images/win/collage-mobile.webp"
                  alt="Winner photos collage"
                  className="h-auto w-full"
                />
              </div>

              {/* ── Desktop collage ─────────────────────────────── */}
              <div className="relative hidden h-[220px] w-full max-w-[715px] lg:block">
                <div className="absolute left-[11px] top-[42px] z-[1] h-[143px] w-[214px] overflow-hidden rounded-xl border-4 border-[#efefef] rotate-[-10deg]">
                  <img
                    src="/assets/images/win/collage-1.webp"
                    alt="Winner photo"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="absolute left-[136px] top-[42px] z-[2] h-[143px] w-[214px] overflow-hidden rounded-xl border-4 border-[#efefef]">
                  <img
                    src="/assets/images/win/collage-3.webp"
                    alt="Winner photo"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="absolute left-[284px] top-[16px] z-[4] h-[185px] w-[278px] overflow-hidden rounded-xl border-4 border-[#efefef] rotate-[-7deg]">
                  <img
                    src="/assets/images/win/collage-4.webp"
                    alt="Winner photo"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="absolute left-[475px] top-[40px] z-[3] h-[143px] w-[214px] overflow-hidden rounded-xl border-4 border-[#efefef] rotate-[5deg]">
                  <img
                    src="/assets/images/win/collage-2.webp"
                    alt="Winner photo"
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ─── Stats row (CMS-driven) ───────────────────────── */}
          {milestonesHtml && <div className="max-lg:-mx-[17px]" dangerouslySetInnerHTML={{ __html: milestonesHtml }} />}
        </div>
      </div>
    </div>
  );
};

export default SaveSection;
